import * as yup from 'yup';

export const bundleSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  externalId: yup
    .string()
    .required('External ID is required')
    .matches(/^\S+$/, 'External ID cannot contain spaces'),
  backgroundImage: yup.string().required('Background image is required'),
  backgroundColor: yup.mixed(),
  buttonSuffixImage: yup.string(),
  buttonSuffixAnimation: yup.string()
});

export const promotionSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  externalId: yup
    .string()
    .required('External ID is required')
    .matches(/^\S+$/, 'External ID cannot contain spaces'),
  backgroundImage: yup.string().required('Background image is required'),
  backgroundColor: yup.mixed(),
  buttonSuffixImage: yup.string(),
  buttonSuffixAnimation: yup.string(),
  collectText: yup
    .string()
    .required('Free Offer Default Text is required'),
  title: yup.string(),
  fontSize: yup.number().min(8).max(20),
  fontWeight: yup.string(),
  fontColor: yup.mixed()
});

export const progressBarSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  externalId: yup
    .string()
    .required('External ID is required')
    .matches(/^\S+$/, 'External ID cannot contain spaces'),
  backgroundOpacity: yup.number().min(0).max(100).required('Background Opacity is required'),
  frameRadius: yup.number().min(0).required('Frame Radius is required'),
  barFillColor: yup.mixed(),
  barBackgroundColor: yup.mixed(),
  barRadius: yup.number().min(0),
  borderColor: yup.mixed(),
  borderWidth: yup.number().min(0),
  accumulatedItemImageUrl: yup.string().required('Accumulated Image is required'),
  textColor: yup.string()
});
